'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var constants = require('./constants.cjs');

"use strict";
const LANGUAGES = [
  { code: constants.ENGLISH_US, name: "English" },
  { code: constants.FRENCH_FRANCE, name: "Fran\xE7ais" },
  { code: constants.SPANISH_SPAIN, name: "Espa\xF1ol" },
  { code: constants.GERMAN_GERMANY, name: "Deutsch" },
  { code: constants.CHINESE_SIMPLIFIED, name: "\u4E2D\u6587\uFF08\u7B80\u4F53\uFF09" },
  { code: constants.BRAZILIAN_PORTUGUESE, name: "Portugu\xEAs Brasileiro" },
  { code: constants.CHINESE_TRADITIONAL, name: "\u4E2D\u6587\uFF08\u7E41\u9AD4\uFF09" },
  { code: constants.ITALIAN_ITALY, name: "Italiano" },
  { code: constants.JAPANESE_JAPAN, name: "\u65E5\u672C\u8A9E" },
  { code: constants.INDONESIAN_INDONESIA, name: "Bahasa Indonesia" },
  { code: constants.KOREAN_KOREA, name: "\uD55C\uAD6D\uC5B4" },
  { code: constants.RUSSIAN_RUSSIA, name: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439" },
  { code: constants.CZECH_CZECHIA, name: "\u010Ce\u0161tina" },
  { code: constants.DUTCH_NETHERLANDS, name: "Nederlands" },
  { code: constants.HUNGARIAN_HUNGARY, name: "Magyar" },
  { code: constants.PORTUGUESE_PORTUGAL, name: "Portugu\xEAs" },
  { code: constants.POLISH_POLAND, name: "Polski" },
  { code: constants.SWEDISH_SWEDEN, name: "Svenska" },
  { code: constants.TURKISH_TURKEY, name: "T\xFCrk\xE7e" }
];

exports.LANGUAGES = LANGUAGES;
//# sourceMappingURL=languages.cjs.map
